import { v4 as uuidV4 } from 'uuid';

import { ExtraItemPayload } from '@features/backOffice/orders/update/components/purchaseMenus/type';
import { CreateOrderItemToppingPayload } from '../../../models/payload/order';
import { OfflineOrderingState } from '../types';

const addItemToMenu = (state: OfflineOrderingState, menuItem: ExtraItemPayload): OfflineOrderingState => {
  const { menuItem: addItem } = menuItem;

  const existMenu = state.menus.filter((x) => x.menuItemId === addItem?.id);

  const exist = existMenu?.some((x) => {
    const check =
      menuItem?.selectedToppings?.length === x?.orderItemToppings?.length &&
      menuItem?.selectedToppings?.every((y) => x?.orderItemToppings?.map((z) => z.toppingId).includes(y?.id));
    return check;
  });

  const menuItemsCount = state.menus?.map((item) => item.count || 0).reduce((a, b) => a + b, 1);

  if (exist) {
    return {
      ...state,
      menus: state.menus.map((item) => {
        if (
          item.menuItemId === addItem.id &&
          menuItem?.selectedToppings.length === item?.orderItemToppings?.length &&
          menuItem?.selectedToppings.every((y) => item?.orderItemToppings?.map((z) => z.toppingId).includes(y?.id))
        ) {
          return {
            ...item,
            count: (item?.count || 0) + 1,
            orderItemToppings: item?.orderItemToppings?.map((x) => ({
              ...x,
              count: (item.count || 0) + 1,
            })),
          };
        }
        return item;
      }),
      showDetails: false,
      selectedTopping: [],
      menuItemsCount,
    };
  }

  return {
    ...state,
    menus: [
      ...state.menus,
      {
        count: 1,
        discount: addItem?.discount || 0,
        menuItemId: addItem?.id || '',
        title: addItem?.title || '',
        price: addItem?.price || 0,
        packagingCost: addItem?.packagingCost || 0,
        servePackagingCost: addItem?.servePackagingCost || 0,
        tempId: uuidV4(),
        orderItemToppings: menuItem?.selectedToppings?.map((x) => ({
          count: 1,
          price: x.price,
          title: x.title,
          toppingId: x.id,
        })) as Array<CreateOrderItemToppingPayload>,
      },
    ],
    showDetails: false,
    selectedTopping: [],
    menuItemsCount,
  };
};

export default addItemToMenu;
